module.exports = __webpack_public_path__ + "static/sanderdoorn_0-bd6b32dbfe81ffdbdeac57d0e27aa99d.jpg";